import {FC, useState} from 'react'
import {useIntl} from 'react-intl'
import axios from 'axios'
import AsyncSelect from 'react-select/async'
import {colourStyles, colourStyles2} from '../../../../components/styles/styles'
import makeAnimated from 'react-select/animated'
import {ErrorMessage, Field, useField} from 'formik'
import {AnimaDireita2} from '../../../../../../../../_metronic/assets/animation/styles'
import Select from 'react-select'
const API_URL = process.env.REACT_APP_API_URL || 'api'

interface UseOption {
  readonly value: number
  readonly label: string
}

const Step1: FC = () => {
  const animatedComponents = makeAnimated()
  const intl = useIntl()
  const [annuity, ,] = useField('annuity')
  const [fieldProvider, , helperProvider] = useField('provider_id')
  const [fieldResponsibleID, metaResponsibleID, helperResponsibleID] = useField('responsible_id')
  const [fieldProjectID, ,] = useField('project_id')
  const [selectedProvider, setSelectedProvider] = useState([])
  const [selectedResponsibleID, setSelectedResponsibleID] = useState([])
  const [disableUsers, setDisableUsers] = useState(false)

  //Inicio funções react-select providers
  //funcção para carregar os dados do select providers
  const loadOptionsprovider = (inputValue: string, callback: (options: UseOption[]) => void) => {
    setTimeout(() => {
      getproviders()
      var providers: any = []
      var options: any[] = []

      //variavel guarda os dados dos inicialmente carregados no provider_id
      let providerIdinit = fieldProvider.value

      //funcação que monta as opções do select
      async function getproviders() {
        const {data} = await axios.get(API_URL + '/v1/providers/select2')
        let Response = data.results

        if (Response) {
          for (var i = 0; i < Response.length; i++) {
            const provider: any = {
              value: Response[i].id,
              label: Response[i].name,
            }

            providers.push(provider)

            //condicional que verifica se tem um provider, e seta o valor como inicial no select
            if (providerIdinit === Response[i].id) {
              options.push(provider)
            }
          }
        }
        setSelectedProvider(options[0])
      }
      callback(providers)
    }, 1000)
  }

  const handleInputChangeProviders = (event: any) => {
    var inputValue = ''
    inputValue = event.value
    setSelectedProvider(event)
    helperProvider.setValue(inputValue)
    return {inputValue}
  }
  //

  //função de load do select2 de usuarios responsaveis -- responsible_id
  const loadOptionsResponsibleID = (
    inputValue: string,
    callback: (options: UseOption[]) => void
  ) => {
    setTimeout(() => {
      getUser()
      var units: any = []
      var options: any[] = []

      let responsibleIdinit = fieldResponsibleID.value

      async function getUser() {
        let project_id = parseInt(fieldProjectID.value)
        const {data} = await axios.get(`${API_URL}/v1/users/select2?sga_project_id=${project_id}`)
        let Response = data.results
        console.log('Response', Response)

        setDisableUsers(false)
        if (Response) {
          for (var i = 0; i < Response.length; i++) {
            const unit: any = {
              value: Response[i].id,
              label: Response[i].username,
            }
            units.push(unit)
            //CONDICIONAL PARA SELECT2 MULTIPLOS
            if (responsibleIdinit) {
              for (var j = 0; j < responsibleIdinit.length; j++) {
                if (parseInt(responsibleIdinit[j]) === Response[i].id) {
                  options.push(unit)
                }
              }
            }
          }
        } else {
          setDisableUsers(true)
        }
        setSelectedResponsibleID(options as any)
      }
      callback(units)
    }, 1000)
  }

  const handleInputChangeResponsibleIDs = (event: any) => {
    var inputValue = []
    if (event) {
      for (var i = 0; i < event.length; i++) {
        inputValue.push(event[i].value)
      }
    }
    setSelectedResponsibleID(event)
    helperResponsibleID.setValue(inputValue)
    return {inputValue}
  }

  return (
    <div className='w-100'>
      <AnimaDireita2>
        <div className='mb-10'>
          <h2 className='fw-bolder text-dark'>{intl.formatMessage({id: 'ACTION_PLANS.STEP1'})}</h2>

          <div className='text-gray-400 fw-bold fs-6'>
            {intl.formatMessage({id: 'ACTION_PLANS.STEP1SUB'})}
          </div>
        </div>

        <div className='card-body  p-0 '>
          {/* inicio da segunda linha */}
          <div className='row'>
            {/* Inicio do select providers */}
            <div className='col-lg-6'>
              <label className='form-label fs-6 fw-bold'>
                {intl.formatMessage({id: 'PROVIDER.TITLE'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <AsyncSelect
                  className='form-control form-control-lg form-control-solid p-1 ps-6'
                  data-kt-license-table-filter='provider_id'
                  styles={colourStyles}
                  cacheOptions
                  {...fieldProvider}
                  loadOptions={loadOptionsprovider}
                  filterOption={(option, inputValue) =>
                    option.label
                      ? option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                      : false
                  }
                  defaultOptions
                  placeholder={intl.formatMessage({id: 'PROVIDER.TITLE'})}
                  value={selectedProvider}
                  onChange={handleInputChangeProviders}
                />
              </div>
            </div>
            {/*  Fim do select providers} */}

            <div className='col-lg-6'>
              <label className='form-label fs-6 fw-bold required'>
                {intl.formatMessage({id: 'USERS_RESPONSIBLE.TITLE'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                {disableUsers ? (
                  <Select
                    className='form-control form-control-lg form-control-transparent p-1 pl-1 ps-6 border border-1 border-gray-400'
                    styles={colourStyles2}
                    isDisabled={true}
                    placeholder='não há usuários disponíveis'
                  />
                ) : (
                  <AsyncSelect
                    className='form-control form-control-lg form-control-solid p-1 pl-1'
                    styles={colourStyles}
                    isMulti
                    components={animatedComponents}
                    cacheOptions
                    {...fieldResponsibleID}
                    loadOptions={loadOptionsResponsibleID}
                    filterOption={(option, inputValue) =>
                      option.label
                        ? option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                        : false
                    }
                    defaultOptions
                    placeholder={intl.formatMessage({id: 'USERS.TITLE'})}
                    value={selectedResponsibleID}
                    onChange={handleInputChangeResponsibleIDs}
                  />
                )}
                {metaResponsibleID.error ? (
                  <div className='text-danger text-center fs-9 fw-bold '>
                    {metaResponsibleID.error}
                  </div>
                ) : null}
              </div>
            </div>
          </div>

          {/* fim da segunda linha */}

          {/* inicio da terceira linha */}
          <div className='row'>
            <div className='col-lg-12'>
              <label className='form-label fs-6 fw-bold required'>
                {intl.formatMessage({id: 'COMMON.DESCRIPTION'})}
              </label>
              <div className='d-flex align-items-center position-relative my-1'>
                <Field
                  as='textarea'
                  name='description'
                  className='form-control form-control-lg form-control-solid'
                  rows={5}
                />
                <div className='text-danger text-center fs-9 fw-bold'>
                  <ErrorMessage name='description' />
                </div>
              </div>
            </div>

            <div className='col-lg-12'>
              <label className='form-label fs-6 fw-bold'>
                {/* {intl.formatMessage({id: 'CONDITIONINGS.ANNUITY'})} */}
                Recorrente
              </label>
              <div className='form-check form-switch form-check-custom form-check-solid fw-bold me-10'>
                <label className='form-check-label'> Não &nbsp;</label>

                <input className='form-check-input w-45px h-30px' type='checkbox' {...annuity} />

                <label className='form-check-label'>Sim </label>
              </div>
            </div>
          </div>

          {/* fim da terceira linha */}
        </div>
      </AnimaDireita2>
    </div>
  )
}

export {Step1}
